module.exports = __webpack_public_path__ + "img/richeng1.daa22f10.png";